import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyConverterPure' })
export class CurrencyConverterPurePipe implements PipeTransform {
  transform(
    value: any,
    fromCurrency: string,
    toCurrency: string,
    currencies: any[]
  ): number {
    if (!value || !fromCurrency || !toCurrency || !currencies?.length) {
      return value;
    }

    value = Number(value);

    // Si es 0, retornar 0 directamente
    if (value === 0) return 0;

    const fromRateObj = currencies.find(c => c.code === fromCurrency);
    const toRateObj = currencies.find(c => c.code === toCurrency);

    if (!fromRateObj || !toRateObj) return value;

    const fromRate = parseFloat(fromRateObj.rate);
    const toRate = parseFloat(toRateObj.rate);

    // Evitar división por 0
    if (fromRate === 0) return value;

    // 1. Usar alta precisión en el cálculo
    // Convertir a números enteros para evitar errores de punto flotante
    const precision = 1000000; // 6 decimales de precisión

    const valueScaled = Math.round(value * precision);
    const fromRateScaled = Math.round(fromRate * precision);
    const toRateScaled = Math.round(toRate * precision);

    // 2. Calcular con enteros: (value / fromRate) * toRate
    // Primero: value / fromRate
    const divisionResult = (valueScaled / fromRateScaled) * precision;

    // Segundo: * toRate
    const multiplicationResult = (divisionResult * toRateScaled) / precision;

    // 3. Convertir de vuelta y redondear apropiadamente
    const result = multiplicationResult / precision;

    // 4. Redondear a 6 decimales para evitar errores en el siguiente pipe
    return Math.round((result + Number.EPSILON) * 1000000) / 1000000;
  }
}
